import {fetchApiClient} from "common/fetchApiClient";
import {API_URL} from "common/const";
import UnauthorizedError from "api/errors/UnauthorizedError";
import { AxiosError } from "axios";
import User from "model/User";


const addPenalty = async (userToPenalty: User, competitionCode: string, leagueId: number, points: number, token: string | undefined): Promise<void> => {
    const apiClient = fetchApiClient(token);

    await apiClient.put(`${API_URL}/penalties/${competitionCode}/${leagueId}`, {
        uid: userToPenalty.uid,
        points: points
    }).catch((error: AxiosError) => {
        console.log(`Error adding a penalty`, competitionCode, leagueId, userToPenalty.uid, points, error);
        if (!!error.response && error.response.status === 403) {
            throw new UnauthorizedError();
        }
        throw error;
    });
}

export default addPenalty;
